<template>
  <loading v-if="loading" />
  <div class="stack lg:grid gap-2 lg:grid-cols-2" v-else>
    <div class="lg:col-span-2 p-8 border border-gray-400 lg:grid lg:grid-cols-2">
      <div>
        <h1>{{$t('dashboard.stats')}}</h1>
        <ul class="list-disc ml-6">
          <li>
            <span class="font-medium">{{ usersCount.total }}</span>
            {{ $tc('dashboard.active_users', usersCount.total)}}
          </li>
          <li>
            <span class="font-medium">{{ allEntries.total }}</span>
            {{ $tc('dashboard.checked_activities', allEntries.total)}}
          </li>
        </ul>
      </div>
      <div></div>
    </div>
    <div class="p-4 border border-gray-400 text-center">
      <h2 class="text-center">{{ $tc('activities.activity_entry', 2) }}</h2>
      <h3 class="text-center">{{ $t('general.period.month') }}</h3>
      <p class="text-sm">{{ entriesMonth.total }} {{ $tc('general.entry', entriesMonth.total)}}</p>
      <statistic-entries
        :entries="entriesMonth.grouped"
        css="bg-blue-500"
        :range="30"
        type="day"
        key="month"
      />
      <h3 class="text-center mt-4">{{ $t('general.period.year') }}</h3>
      <p class="text-sm">{{ entriesYear.total }} {{ $tc('general.entry', entriesYear.total)}}</p>
      <statistic-entries :entries="entriesYear.grouped" :range="365" type="week" key="year" />
    </div>
    <div class="p-4 border border-gray-400 text-center row-span-2">
      <h2 class="text-center">{{ $tc('general.user', 2) }}</h2>
      <h3 class="text-center">{{ $t('general.period.month') }}</h3>
      <p class="text-sm">{{ newUsersMonth.total }} {{ $t('dashboard.new_users')}}</p>
      <statistic-entries :entries="newUsersMonth.grouped" :range="30" type="day" key="month" />
      <h3 class="text-center mt-4">{{ $t('general.period.year') }}</h3>
      <p class="text-sm">{{ newUsersYear.total }} {{ $t('dashboard.new_users')}}</p>
      <statistic-entries :entries="newUsersYear.grouped" :range="365" type="week" key="year" />
    </div>
    <div class="p-4 border border-gray-400 text-center">
      <h2 class="text-center">{{ $tc('targets.target', 2) }}</h2>
      <h3 class="text-center">{{ $t('general.period.month') }}</h3>
      <p
        class="text-sm"
      >{{ targetsCreatedMonth.total }} {{ $tc('targets.target_created', targetsCreatedMonth.total)}}</p>
      <statistic-entries :entries="targetsCreatedMonth.grouped" :range="30" type="day" key="month" />
      <h3 class="text-center mt-4">{{ $t('general.period.year') }}</h3>
      <p
        class="text-sm"
      >{{ targetsCreatedYear.total }} {{ $tc('targets.target_created', targetsCreatedYear.total)}}</p>
      <statistic-entries :entries="targetsCreatedYear.grouped" :range="365" type="week" key="year" />
    </div>
  </div>
</template>

<script>
const StatisticEntries = require("@/modules/dashboard/components/StatisticEntries.vue")
  .default;

export default {
  name: "Dashboard",
  data() {
    return {
      entriesMonth: [],
      entriesYear: [],
      newUsersMonth: [],
      newUsersYear: [],
      usersCount: [],
      allEntries: [],
      targetsCreatedMonth: [],
      targetsCreatedYear: []
    };
  },
  props: {},
  components: {
    StatisticEntries
  },
  methods: {},
  computed: {},
  async created() {
    this.entriesMonth = await this.$store.getters["activityentry/api"].Stats({
      range: 30,
      type: "daily"
    });
    this.entriesYear = await this.$store.getters["activityentry/api"].Stats({
      range: 365,
      type: "weekly"
    });
    this.allEntries = await this.$store.getters["activityentry/api"].Stats({
      range: 0
    });

    this.newUsersMonth = await this.$store.getters["user/api"].Stats({
      range: 30,
      type: "daily"
    });
    this.newUsersYear = await this.$store.getters["user/api"].Stats({
      range: 365,
      type: "weekly"
    });

    this.targetsCreatedMonth = await this.$store.getters["target/api"].Stats({
      range: 30,
      type: "daily"
    });
    this.targetsCreatedYear = await this.$store.getters["target/api"].Stats({
      range: 365,
      type: "weekly"
    });

    this.usersCount = await this.$store.getters["user/api"].Stats({
      range: 0
    });

    this.loaded();
  }
};
</script>